import { IFieldSetPartial } from '../../../lib/mighty-fields';

/**
 * The contact form, used both to create one and to edit one afterwards. The same fields the case
 * contact form asks for, less the type -- every contact here is an invoicing and payments contact.
 *
 * A name is required because it is all the table has to identify a row by; the ways of reaching the
 * contact are not, one of them being enough and the API asking for none of them.
 */
export const CONTACT_FIELD_SETS: IFieldSetPartial[] = [
  [
    { field: 'first_name', required: true },
    { field: 'last_name', required: true },
  ],
  [
    { field: 'email', label: 'Email Address', type: 'email' },
    { field: 'phone_number', label: 'Phone #', type: 'phone' },
    { field: 'additional_contact_info.cell_number', label: 'Cell #', type: 'phone' },
    { field: 'additional_contact_info.fax_number', label: 'Fax #', type: 'phone' },
  ],
  [
    { field: 'summary', label: 'Notes', type: 'textDynamic' },
  ],
];
